import Vue from "vue";

import {VueEditor} from "vue2-editor";
Vue.use('vue-editor', VueEditor);